import { type IConversions } from "./IConversions";

/*
 * A static conversion that converts list items according to {key: value} in an object.
 */
export class StaticConversions<S extends string | number, T> implements IConversions<S, T> {
	private conversions: Record<S, T>;

	constructor(conversions: Record<S, T>) {
		this.conversions = conversions;
	}

	data(key: S): T {
		return this.conversions[key];
	}

	load() {
		return Promise.resolve();
	}

	invalidate(): Promise<void> {
		throw Error("a StaticConversion cannot invalidate its entries, they are fixed at construction");
	}

	get isResetting(): number {
		return 0;
	}
}
